import { FILTER_TYPES } from '../../constants/TopFilterConstants';
export const MY_LEARNING_FILTERS = {
  all: [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.PROGRESS_STATUS, FILTER_TYPES.CONTENT_TYPE, FILTER_TYPES.SEARCH],
  'courses-and-lessons': [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.PROGRESS_STATUS, FILTER_TYPES.SEARCH],
  videos: [FILTER_TYPES.SEARCH],
  playlists: [FILTER_TYPES.PROGRESS_STATUS, FILTER_TYPES.SEARCH]
};
export const MyLearningTabTypeToRequestMapping = {
  all: [],
  'courses-and-lessons': ['TRACK', 'LESSON', 'TEMPLATE', 'EBOOK'],
  videos: ['SHORT_FORM_CONTENT'],
  playlists: ['PLAYLIST', 'LEARNING_PATH']
};
export const ContentTypesFilterToMyLearningRequestMapping = {
  COURSE: ['TRACK'],
  LESSON: ['LESSON'],
  SHORT_FORM_CONTENT: ['SHORT_FORM_CONTENT'],
  TEMPLATE: ['TEMPLATE'],
  EBOOK: ['EBOOK'],
  LEARNING_PATH: ['PLAYLIST', 'LEARNING_PATH']
};
export const ProgressTypeFilterToMyLearningRequestMapping = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  NOT_STARTED: undefined,
  EXPIRING_SOON: undefined
};